import React, { useState } from 'react';
import OffersList from './OffersList';
import InvitationsList from './InvitationsList';
import ReferralsList from './ReferralsList';

const VIEWS = [
  { id: 'offers', label: 'Offers' },
  { id: 'invitations', label: 'Invitations' },
];

/** Opportunities and invitations for one programme. Parent and mentor proposals for this
 *  programme sit inside Offers, tagged with who proposed them. */
export default function CompaniesOffersTab({ program, focus, onChanged }) {
  const [view, setView] = useState('offers');
  const [offersKey, setOffersKey] = useState(0);
  const counts = {
    offers: program.metrics.opportunities,
    invitations: null,
  };
  const proposalActioned = () => { setOffersKey(k => k + 1); onChanged?.(); };

  return (
    <div data-testid="companies-offers-tab">
      <div className="flex gap-1 mb-4 bg-[#F3F4F6] rounded-lg p-1 w-fit">
        {VIEWS.map(v => (
          <button key={v.id} onClick={() => setView(v.id)}
            className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-colors whitespace-nowrap ${view === v.id ? 'bg-white text-[#1F2937] shadow-sm' : 'text-[#6B7280] hover:text-[#1F2937]'}`}
            data-testid={`companies-view-${v.id}`}>
            {v.label}{counts[v.id] ? ` (${counts[v.id]})` : ''}
          </button>
        ))}
      </div>
      {view === 'offers' && (
        <>
          <ReferralsList programId={program.id} embedded onChanged={proposalActioned} />
          <OffersList key={offersKey} programId={program.id} focus={focus} onChanged={onChanged} />
        </>
      )}
      {view === 'invitations' && <InvitationsList program={program} onChanged={onChanged} />}
    </div>
  );
}
